import { Alert, type AlertProps, Box, useTheme } from 'ui';

import { relativeZIndex } from '../../config';

export const InfoText = ({
  showAlert,
  message,
  severity = 'error',
}: {
  showAlert: boolean;
  message: string;
  severity?: AlertProps['severity'];
}) => {
  const theme = useTheme();

  return showAlert ? (
    <Box position="absolute" display="flex" justifyContent="center" width="100%" top="5%">
      <Alert
        severity={severity}
        sx={{
          zIndex: theme.zIndex.modal + relativeZIndex.infoText,
        }}
      >
        {message}
      </Alert>
    </Box>
  ) : null;
};
